import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import SignUpService from '@/app-domains/user/onboarding/signup.service'
import './SignUpFirstStep.scoped.sass'
import { InputMask } from '@/components/InputMask/InputMask'
import { Button } from '@/components/Button/Button'
import validator from 'validator'
import ToastService from '@/components/Toast/Toast.service'
// eslint-disable-next-line
import { SocialLoginSection } from '@/pages/LoginPage/components/SocialLoginSection/SociaLoginSection'
import commonsService from '@/services/commons.service'
import { removeItemFromLocalStorage, saveItemInLocalStorage } from '@/core/localstorage'

export function SignUpFirstStep () {
  const [submitting, setSubmitting] = useState(false)
  const [firstName, setFirstName] = useState('')
  const [firstNameError, setFirstNameError] = useState('')
  const [email, setEmail] = useState('')
  const [emailError, setEmailError] = useState('')
  const [password, setPassword] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [invitationalCode, setInvitationalCode] = useState('')
  const [userHasPromoCode, setUserHasPromoCode] = useState(false)
  const [isFreeTrial, setIsFreeTrial] = useState(false)

  const handleFullNameChange = (firstName) => {
    validateFullName(firstName)
    setFirstName(firstName)
  }

  const validateFullName = (value) => {
    if (!value) {
      setFirstNameError('Full name cannot be empty')
      return false
    } else {
      setFirstNameError('')
      return true
    }
  }

  const handleEmailChange = (email) => {
    validateEmail(email)
    setEmail(email)
  }

  const validateEmail = (value) => {
    if (!validator.isEmail(value)) {
      setEmailError('Email doesn\'t have a valid format')
      return false
    } else {
      setEmailError('')
      return true
    }
  }

  const handlePassChange = (password) => {
    validatePass(password)
    setPassword(password)
  }

  const validatePass = (value) => {
    if (value.length < 8 || !/(?=.*[a-z])(?=.*[A-Z]).{8,}/.test(value)) {
      setPasswordError('Password should have at least 8 characters combining uppercase and lowercase ones')
      return false
    } else {
      setPasswordError('')
      return true
    }
  }

  const handleInvitationalCodeChange = (invitationalCode) => {
    setInvitationalCode(invitationalCode.replace(/"/g, ''))
  }

  const togglePromoCode = () => {
    setUserHasPromoCode(!userHasPromoCode)
    if (invitationalCode) {
      setInvitationalCode('')
    }
  }

  const doesFormHasAnyError = () => {
    const firstNameValidation = validateFullName(firstName)
    const emailValidation = validateEmail(email)
    const passValidation = validatePass(password)
    return (!firstNameValidation || !emailValidation ||
    !passValidation)
  }

  const onSubmitHandler = (e) => {
    if (submitting) return e?.preventDefault()
    if (doesFormHasAnyError()) {
      ToastService.show({
        type: 'error',
        title: 'Error',
        message: 'There are some validation errors',
      })
      return e?.preventDefault()
    }
    // Validate here

    setSubmitting(true)
    SignUpService.sendUserCrendentials(
      firstName,
      email,
      password,
      invitationalCode).then(() => setSubmitting(false))
      .catch(() => setSubmitting(false))
    e?.preventDefault()
  }

  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const code = query?.get('invite')
    if (code) {
      setUserHasPromoCode(true)
      setInvitationalCode(code)
    }
  }, [])

  useEffect(() => {
    const type = commonsService.getQueryParams('type')
    if (type === 'free-trial') {
      setIsFreeTrial(true)
      saveItemInLocalStorage('isfreetrial', true)
    } else {
      setIsFreeTrial(false)
      removeItemFromLocalStorage('isfreetrial')
    }
  }, [])

  return <div className='sign-up-container'>
    <Link to={'/auth'} className="existing-account-link">Already have an account?</Link>
    
    <form className='login-form'>
      <div className='login-heading-text'>
        Let's start your Boxes journey!
      </div>
      <div className="login-input">
        <InputMask errorMessage={firstNameError} required={true} onInput={handleFullNameChange} width='300px' label="What's your full name?"/>
      </div>
      <div className="login-input">
        <InputMask errorMessage={emailError} required={true} onInput={handleEmailChange} width='300px' label="What's your current email address?"/>
      </div>
      <div className="login-input">
        <InputMask placeholder='Your Boxes password' helperTitle='Password requirements' helperMessage='We require your password to be 8 upper/lower characters but you can use symbols and numbers too. Please remember that longer passwords are more secure and can be easier to remember. Try grouping different words together to create a longer password.
Use unpredictable phrases that are funny or easy to remember.
Like StarWarsIsMyFav or BeatlesMusicDelivers or NotAllVioletsAreBlue -- be creative and original!' errorMessage={passwordError} required={true} onInput={handlePassChange} type='password' label='Set up your password'/>
      </div>
      { !isFreeTrial && <div className="login-input promo-code-input">
        { !userHasPromoCode && <div className='promo-code-input-text' onClick={togglePromoCode}>
          Do you have a promo code?
        </div>
        }
        { userHasPromoCode &&
          <><InputMask required={true} onInput={handleInvitationalCodeChange} label='Promo code' value={invitationalCode}/>
            <div className='promo-code-input-text mt-m' onClick={togglePromoCode}>
              I don't have a promo code
            </div></> }
      </div> }
      <div className='signup-terms-and-conditions'>
        By signin up, you accept our <a href="https://app.boxes.im/terms-and-conditions.html">Terms and conditions</a>
      </div>
      <div className="login-button">
        <Button content="Create account" click={onSubmitHandler} size="large" disabled={submitting}/>
      </div>
      
      {/*
        <SocialLoginSection pageName='register'/>
        */}
    </form>
  </div>
}
